<template>
  <div class="summaries">
    <b-table class="gl-table" :data="groupedLogsData" :hoverable="true"
             :mobile-cards="false" :loading="isLoading" @click="groupedLogSelected"
             :show-header="false" :selected.sync="selected_row">
      <b-table-column field="duration_summary" :label="this.$t('grouped-logs.duration-summary-column')"
                      v-slot="props">
        <div class="gl-row">
          <div class="gl-row__left">
            <span class="gl-row__day">{{ getFormattedDate(props.row.grouped_log.date) }}</span>
            <b-icon v-if="isHavingValue(props.row.grouped_log) && !isProjectSummaryHoursValid(props.row.grouped_log)"
                    icon="alert-circle" size="is-small" type="is-danger" />
          </div>
          <div v-if="isHavingValue(props.row.grouped_log)" class="gl-row__right">
            <span class="gl-row__amount" :style="profitTextStyle(props.row.grouped_log.total_profit)">
              {{ getFormattedPricing(toFixedIfNecessary(props.row.grouped_log.total_profit)) }}
            </span>
            <div class="gl-bar">
              <i :class="props.row.grouped_log.total_profit >= 0 ? 'is-pos' : 'is-neg'"
                 :style="{ width: profitBarWidth(props.row.grouped_log.total_profit) }"></i>
            </div>
          </div>
        </div>
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "GroupedLogs",
  components: {},
  props: {
    'project_id': {
      type: String,
    }
  },
  data() {
    return {
      isLoading: false,
      groupedLogsData: [],
      maxDurationValue: null,
      maxProfitValue: null,
      selected_row: {}
    }
  },
  methods: {
    readProjectSummary: function () {
      this.isLoading = true
      this.groupedLogsData = []
      const functions = firebase.app().functions(this.$brand.functionsRegion);
      const getProjectSummaryFunction = functions.httpsCallable(this.getSubmitEndpoint());
      getProjectSummaryFunction({action: "get_project_summary", document_id: this.project_id, fill_meta: true})
          .then((result) => {
            const internalDurations = result.data.grouped_logs.map(log => log.total_logged_durations_internal_personnel);
            const externalDurations = result.data.grouped_logs.map(log => log.total_logged_durations_external_personnel);
            const allDurations = internalDurations.concat(externalDurations)
            this.maxDurationValue = Math.max.apply(Math, allDurations)
            this.maxProfitValue = Math.max.apply(Math, result.data.grouped_logs.map(log => Math.abs(log.total_profit)))
            if (result.data.grouped_logs.length > 0) {
              result.data["grouped_logs"].forEach((grouped_log) => {
                this.groupedLogsData.push({
                  grouped_log: grouped_log
                });
              });
            }
            this.isLoading = false
            if (this.groupedLogsData[0] !== undefined) {
              this.groupedLogSelected(this.groupedLogsData[0])
            }
          })
          .catch((error) => {
            this.isLoading = false
            this.showError(error.message)
            console.log("Error get_project_summary: ", error?.code);
          });
    },
    profitBarWidth: function (profit) {
      if (!this.maxProfitValue) return '0%'
      return Math.min(Math.abs(profit) / this.maxProfitValue * 100, 100) + '%'
    },
    /*
     UI Events
     */
    groupedLogSelected: function (groupLog) {
      if (this.isHavingValue(groupLog.grouped_log)) {
        this.selected_row = groupLog
      } else {
        this.selected_row = null
      }
      this.$emit("groupLogSelected", groupLog)
    }
  },
  mounted() {
    this.readProjectSummary();
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/tokens";

.summaries { width: 100%; }
.gl-table { margin: 0; }

// Tokenised list rows — no table chrome, hover tint, brand-accent on the selected day.
::v-deep .gl-table table { background: transparent; }
::v-deep .gl-table td {
  border: 0;
  border-bottom: 1px solid $omx-ink-100;
  padding: 0;
}
::v-deep .gl-table tbody tr:last-child td { border-bottom: 0; }
::v-deep .gl-table tbody tr:hover:not(.is-selected) td { background: $omx-ink-50; }
::v-deep .gl-table tbody tr.is-selected td {
  background: $omx-brand-50 !important;
  color: $omx-ink-900 !important;
  box-shadow: inset 3px 0 0 $omx-brand-600;
}

.gl-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  min-height: 56px;
}
.gl-row__left { display: flex; align-items: center; gap: 8px; }
.gl-row__day { font-weight: 700; color: $omx-ink-900; font-variant-numeric: tabular-nums; }
.gl-row__right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}
.gl-row__amount { font-size: 14px; font-variant-numeric: tabular-nums; }
.gl-bar {
  width: 110px;
  height: 7px;
  border-radius: 999px;
  background: $omx-ink-100;
  overflow: hidden;
}
.gl-bar > i { display: block; height: 100%; border-radius: 999px; }
.gl-bar > i.is-pos { background: $omx-success-600; }
.gl-bar > i.is-neg { background: $omx-danger-600; }
</style>
